/* eslint-disable global-require */
import React from 'react';
import {
  openComponentTooltip,
  closeComponentTooltip,
} from 'actions/BotActions';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';

export default class Icon extends React.Component {
  render() {
    const { tooltip } = this.props;
    const svgProps = {
      className: this.props.className || '',
      onClick: this._handleClick,
      onMouseEnter: tooltip && this._showTooltip,
      onMouseLeave: tooltip && this._hideTooltip,
    };

    const Icon = this._getIcon();
    if (!Icon) return null;
    return (
      <span
        className={this.props.containerClassName || ''}
        ref={(DOMElement) => {
          this._svg = DOMElement;
          if (this.props.innerRef) {
            this.props.innerRef(DOMElement);
          }
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: this.props.size,
          height: this.props.size,
        }}
      >
        <Icon width={this.props.size} height={this.props.size} {...svgProps} />
      </span>
    );
  }

  _renderTooltip = () => {
    if (typeof this.props.tooltip === 'string') {
      return (
        <div
          style={{ maxWidth: this.props.maxTooltipWidth || 'auto' }}
          className="default-tooltip"
          dangerouslySetInnerHTML={{ __html: HelperUtils.htmlEscape(this.props.tooltip) }}
        />
      );
    }
    if (typeof this.props.tooltip === 'object') {
      return (
        <div
          style={{ maxWidth: this.props.maxTooltipWidth || 'auto' }}
          className="default-tooltip"
        >
          {this.props.tooltip}
        </div>
      );
    }
  };

  _handleClick = (e) => {
    if (this._timeout) {
      clearTimeout(this._timeout);
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _showTooltip = () => {
    this._timeout = setTimeout(() => {
      const destinationRect = this._svg.getBoundingClientRect();
      const position = {
        x: destinationRect.left + destinationRect.width / 2,
        y: destinationRect.top - destinationRect.height,
      };
      openComponentTooltip(
        position,
        this._renderTooltip(),
        'TOP',
        destinationRect
      );
    }, 500);
  };

  _hideTooltip = () => {
    if (this._timeout) {
      clearTimeout(this._timeout);
    }
    closeComponentTooltip();
  };

  _getIcon = () => {
    switch (this.props.iconType) {
      case 'lock-close':
        return require('./lock-close.svg');
      case 'lock-open':
        return require('./lock-open.svg');
      case 'info':
        return require('./info.svg');
      case 'user-says':
        return require('./user-says.svg');
      case 'bot-says':
        return require('./bot-says.svg');
      case 'entities':
        return require('./entities.svg');
      case 'connections':
        return require('./connections.svg');
      case 'api':
        return require('./api.svg');
      case 'currency':
        return require('./currency.svg');
      case 'gear':
        return require('./gear.svg');
      case 'close':
        return require('./close.svg');
      case 'inactive':
        return require('./inactive.svg');
      case 'active':
        return require('./active.svg');
      case 'edit':
        return require('./edit.svg');
      case 'invisible':
        return require('./invisible.svg');
      case 'visible':
        return require('./visible.svg');
      case 'save':
        return require('./save.svg');
      case 'help':
        return require('./help.svg');
      case 'add':
        return require('./add.svg');
      case 'trash':
        return require('./trash.svg');
      case 'home':
        return require('./home.svg');
      case 'synonym_highlight':
        return require('./synonym-highlight.svg');
      case 'synonym_duplicate':
        return require('./synonym-duplicate.svg');
      case 'plus':
        return require('./plus.svg');
      case 'add-delay':
        return require('./add-delay.svg');
      case 'add-entity':
        return require('./add-entity.svg');
      case 'bot-says-colored':
        return require('./bot-says-colored.svg');
      case 'delay':
        return require('./delay.svg');
      case 'entity':
        return require('./entity.svg');
      case 'entity-numeric-range':
        return require('./entity-numeric-range.svg');
      case 'entity-regex':
        return require('./entity-regex.svg');
      case 'budget':
        return require('./budget.svg');
      case 'date':
        return require('./date.svg');
      case 'time':
        return require('./time.svg');
      case 'reorder':
        return require('./reorder.svg');
      case 'mandatory':
        return require('./mandatory.svg');
      case 'deprecated':
        return require('./deprecated.svg');
      case 'attachment':
        return require('./attachment.svg');
      case 'tick':
        return require('./tick.svg');
      case 'star':
        return require('./star.svg');
      case 'angle-down':
        return require('./angle-down.svg');
      case 'node':
        return require('./node.svg');
      case 'story':
        return require('./story.svg');
      case 'upload_icon':
        return require('./upload-icon.svg');
      case 'task':
        return require('./task.svg');
      case 'task_gray':
        return require('./task-grey.svg');
      case 'taskbox':
        return require('./taskbox.svg');
      case 'outlier':
        return require('./outlier.svg');
      case 'business':
        return require('./business.svg');
      case 'botbreak':
        return require('./botbreak.svg');
      case 'bot':
        return require('./bot.svg');
      case 'user_feedback':
        return require('./user_feedback.svg');
      case 'checkmark':
        return require('./checkmark.svg');
      case 'entity-email':
        return require('./entity-email.svg');
      case 'client':
        return require('./client.svg');
      case 'search':
        return require('./search.svg');
      case 'filter':
        return require('./filter.svg');
      case 'filter_filled':
        return require('./filter_filled.svg');
      case 'transfer':
        return require('./transfer.svg');
      case 'empty-business-placeholder':
        return require('./empty-business-placeholder.svg');
      case 'error_response':
        return require('./red-exclamation.svg');
      case 'success_response':
        return require('./tick-green.svg');
      case 'tick-green':
        return require('./tick-green.svg');
      case 'question':
        return require('./question.svg');
      case 'question-blue':
        return require('./question-blue.svg');
      case 'question-book':
        return require('./question-book.svg');
      case 'arrow':
        return require('./arrow.svg');
      case 'test-bot':
        return require('./test-bot.svg');
      case 'substory-empty':
        return require('./substory-empty.svg');
      case 'quotes_open':
        return require('./quotes_open.svg');
      case 'quotes_close':
        return require('./quotes_close.svg');
      case 'template':
        return require('./template.svg');
      case 'template_general':
        return require('./template_general.svg');
      case 'template_substory':
        return require('./template_substory.svg');
      case 'template_substory_api':
        return require('./template_substory_api.svg');
      case 'circle-more':
        return require('./circle-more.svg');
      case 'paste':
        return require('./paste.svg');
      case 'interchange':
        return require('./interchange.svg');
      case 'down':
        return require('./down.svg');
      case 'calender':
        return require('./calender.svg');
      case 'edit-pencil':
        return require('./edit-pencil.svg');

      // Entity Category icons
      case 'entity-category-public':
        return require('./entity-category-public.svg');
      case 'entity-category-bot':
        return require('./entity-category-bot.svg');
      case 'entity-category-deprecated':
        return require('./entity-category-deprecated.svg');

      // Entity Type Icons
      case 'entity-type-default':
        return require('./entity-type-default.svg');
      case 'entity-type-text':
        return require('./entity-type-text.svg');
      case 'entity-type-date':
        return require('./entity-type-date.svg');
      case 'entity-type-numeric_range':
        return require('./entity-type-numeric_range.svg');
      case 'entity-type-regex':
        return require('./entity-type-regex.svg');
      case 'prompt-trigger':
        return require('./prompt-trigger.svg');
      case 'teams':
        return require('./teams.svg');
      case 'globe':
        return require('./globe.svg');
      case 'platform':
        return require('./platform.svg');
      case 'partner':
        return require('./partner.svg');
      default:
        return undefined;
    }
  };
}
